import { request, toQuery } from './client';

export type EnrollmentProgram = {
	id: number;
	title: string;
};

export type Enrollment = {
	id: number;
	program_id: number;
	program: EnrollmentProgram | null;
	status: string;
	enrolled_at: string;
};

export type EnrollmentsListResponse = { enrollments: Enrollment[] };

export const enrollmentsApi = {
	list: (params?: { client_id?: number }) =>
		request<EnrollmentsListResponse>('/enrollments' + toQuery(params)),
};
